<template>
    <div class="comment-list" shadow="always">
        <div style="margin-bottom:10px;margin-right: 10px;text-align: right;">
            <!--<Tinymce :height=200 ref="editor" v-model="comment.content"></Tinymce>-->
            <!--<Editorbar id="editor" v-model="comment.content" :isClear="isClear"></Editorbar>-->
        <!--    <el-popover
              placement="right"
              width="400"
              trigger="click">

              <Editorbar v-model="comment.content" :isClear="isClear" @change="setContent" @sendClick="handleCommentAdd()"></Editorbar>
            </el-popover> -->
              <el-button  type="primary" icon="el-icon-chat-dot-square" plain size="mini" style="float: right;margin-right: 15px;" @click="handleCommentClick">发表留言</el-button>
     <!--     <el-popover
              placement="left"
              width="30vw"
              trigger="click">
              <Editorbar v-model="comment.content" :isClear="isClear" @change="setContent" @sendClick="handleCommentAdd()"></Editorbar>
              <el-button slot="reference" type="primary" icon="el-icon-chat-dot-square">发表留言</el-button>
            </el-popover> -->


        </div>
        <div class="content-list">
            <div id='top'></div>
            <div v-for="comment in list" :key="comment.id" class="comment-item">
                <div class="comment-detail">
                    <div class="comment-date">{{comment.trueName}} : {{ comment.created }}
                      <el-button  type="success" circle icon="el-icon-chat-line-square" style=" margin-left: 10px;"  @click="handleReplyCommentClick(comment,comment)" title="回复"></el-button>
                      <el-button v-if="comment.createdBy == currentUserId && isMsgToUsers && comment.texts" class="comment-del" @click="chooseUser(comment)" type="info" circle  icon="el-icon-message-solid" style=" margin-left: 10px;" title="发送微信提醒"></el-button>
                      <el-button v-if="comment.createdBy == currentUserId " class="comment-del" @click="handleCommentDelete(comment)" type="danger" circle  icon="el-icon-delete" style=" margin-left: 10px;" title="删除"></el-button>
                    <!-- <div v-if="comment.createdBy == currentUserId " @click="handleCommentDelete(comment)"><i title="删除" class="el-icon-delete comment-del"></i></div></div> -->
                    </div>
                    <p v-html="comment.comments"></p>
                    <el-collapse v-if="comment.replyNum>0" accordion>
                        <el-collapse-item>
                            <template slot="title">
                                <el-button  type="info" plain slot="reference" class="button-info button-all-reply">共{{comment.replyNum}}条回复</el-button>
                            </template>
                            <div v-for="replyComment in comment.replyList" :key="replyComment.id" class="comment-item">
                                <div class="reply-comment-detail">
                                    <div class="comment-date">{{replyComment.trueName}} 回复 {{replyComment.replyToName}}: {{ replyComment.created }}
                                      <el-button  type="success" icon="el-icon-chat-line-square" circle style=" margin-left: 15px;" @click="handleReplyCommentClick(comment,replyComment)" title="回复"></el-button>
                                      <el-button v-if="replyComment.createdBy == currentUserId " class="comment-del" @click="handleCommentDelete(replyComment)" type="danger" circle  icon="el-icon-delete" style=" margin-left: 15px;" title="删除"></el-button>
                                    </div>
                                    <p v-html="replyComment.comments"></p>
                                </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
            </div>
        </div>
      <el-dialog
            title=""
            append-to-body
            :modal="false"
            :visible.sync="isShowEditorbar"
            :class="'commit-message'"
            custom-class="diagram-dialog">
             <Editorbar v-model="comment.content" :key="loadTimer" :isClear="isClear" @change="setContent" @sendClick="handleCommentAdd"></Editorbar>
        </el-dialog>
        <div class="showPic">
            <img src="#" alt="">
        </div>
    </div>
</template>
<script>
    import { isEmpty } from 'lodash';
    import Tinymce from '@/components/Tinymce';
    import Editorbar from '@/components/WangEditor';
    import $ from 'jquery';
    export default {
        components: {
            Tinymce,
            Editorbar
        },
        data () {
            return {
                loadTimer: '',
                isShowEditorbar: false,
                comment: {
                    content: '',
                    mainId: '',
                    supId: '',
                    text: ''
                },
                isClear: false,
                currentUserId: ''
            };
        },
        mounted: function () {
            this.$nextTick(function () {
                $(function () {
                    $('.content-list').on('click', 'img', function () {
                        let picSrc = $(this).attr('src');
                        $('.showPic img').attr('src', picSrc);
                        $('.showPic').show();
                    });
                    $('.showPic').on('click', function () {
                        $('.showPic').hide();
                    });
                });
            });
        },
        props: {
            list: {
                type: Array
            },
            isMsgToUsers: {
                type: Boolean,
                default: false
            }
        },
        created () {
            this.init();
        },
        methods: {
            init () {
                let currentUserStr = sessionStorage.getItem('currentUserInfo');
                let currentUserInfo = JSON.parse(currentUserStr);
                this.currentUserId = currentUserInfo.userId;
            },
            handleCommentClick () {
                this.loadTimer = new Date().getTime();
                this.isShowEditorbar = true;
            },
            setContent (content, text) {
                this.comment.content = content;
                this.comment.text = text;
            },
            handleCommentAdd (content, text) {
                // console.log(content);
                if (isEmpty(content)) {
                    this.$message({message: '评论内容不能为空', type: 'warning'});
                    return;
                }
                this.comment.content = content;
                this.comment.text = text;
                this.$emit('commentAdd', this.comment);
                this.comment.content = '';
                this.comment.mainId = '';
                this.comment.supId = '';
                this.isShowEditorbar = false;
            },
            handleCommentDelete (comment) {
                this.$emit('commentDelete', comment);
            },
            handleSendCommentMsg (comment) {
                this.$emit('commentSend', comment);
            },
            handleShow () {
                // console.log('handleShow');
                this.$refs.inputRef.focus();
            },
            handleReplyCommentClick (subject, targetComment) {
                this.loadTimer = new Date().getTime();
                // document.getElementById('top').focus();//建立锚点，解决复选框获取焦点后，然后下滑，再次点击回复，回不到顶部的问题
                // console.log(subject);
                this.comment.mainId = subject.id;// 话题ID
                this.comment.supId = targetComment.id;// 回复给哪条评论
                // console.log(this.comment);
                // 鼠标焦点定位到富文本框
                // document.getElementsByClassName('w-e-text')[0].focus();
                this.isShowEditorbar = true;
            },
            chooseUser (comment) {
                this.$emit('commentSend', comment);
            }

        }
    };
</script>

<style lang="less">
    .comment-list {
        .content-list {
            margin-top: 30px;
            height: auto;
            overflow-y: auto;
        }
        .comment-item {
            font-size: 12px;
            // margin: 0 0 15px 0;
            display: flex;
            flex-direction: row;
        }

        .comment-item:hover {
            .comment-del {
                visibility: visible;
            }
        }

        .comment-detail {
            flex: 1;
        }

        .comment-date {
            color: #adadad;
        }

        .comment-del {
            visibility: hidden;
            cursor: pointer;
        }

        .button-send {
            float: right;
            padding: 3px 0;
            margin-right: 15px;
        }

        img{
            height:100px;
        }

        .button-info {
            float: left;
            padding: 3px 0;
            margin-top: 5px;
        }

        .el-collapse-item__header {
            height: auto !important;
            margin-left: 35px;
            border: 0px;
        }

        .el-collapse-item__arrow {
            margin: 3px auto 0 8px !important;
        }

        .reply-comment-detail {
            margin-left: 30px;
            flex: 1;
        }
    }
    .showPic{
        display: none;
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background:rgba(255, 255, 255, 0.678);
        img{
            z-index: 11;
            width: 400px;
            height: 400px;
            position: fixed;
            top: 50%;
            margin-left: -150px;
            margin-top: -150px;
            left: 50%;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/process/components/Comment/Comment.vue